import React from 'react';

import { Typography, IconButton, Box } from '@mui/material';
import { DialogTitle as MuiDialogTitle } from '@mui/material';
import {  Close as CloseIcon, ArrowBack } from '@mui/icons-material';
import { styled } from '@mui/system';
import { useSelector } from 'react-redux';
import { goBack } from '../../redux/actions/ui.actions';
const DialogTitle = styled(MuiDialogTitle)(({ theme }) =>
  theme.unstable_sx({
    '&': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: 0,
      px: 3,
      pt: 3,
    },
    '& .company-logo-name': {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
    },
  })
);

const Component = ({ title, onClose, classes }) => {
  const breadcrumbs = useSelector((state) => state.navigation.breadcrumbs);
  const entity = useSelector((state) => state.entities.selectedEntity);
  const page = useSelector((state) => state.navigation.page);
  const company = useSelector((state) => state.preferences.company);
  const hideBackButtons = useSelector((state) => state.configuration.hideBackButtons);
  const renderEntityHeader =
    page === 'EntityConfig' ||
    page === 'SyncSchedule' ||
    page === 'FieldMapSelector' ||
    page === 'FieldMapSelectorV2' ||
    page === 'FieldMapTransferList';

  const isRightAligned = !renderEntityHeader && !(breadcrumbs.length >= 2) && !company;
  return (
    <DialogTitle
      component="div"
      sx={{
        position: isRightAligned ? 'absolute' : 'relative',
        top: isRightAligned ? '0' : 'auto',
        right: isRightAligned ? '0' : 'auto',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        pb: page === 'ConnectParams' ? 0 : 2,
      }}
    >
      {page !== 'EntityConfig' && (
        <Box
          width={1}
          display="flex"
          justifyContent={breadcrumbs.length >= 1 && !hideBackButtons ? 'space-between' : 'flex-end'}
        >
          {breadcrumbs.length >= 1 && !hideBackButtons && (
            <Box display="flex" gap={1.5} alignItems="center" onClick={() => goBack()} sx={{ cursor: 'pointer' }}>
              <ArrowBack color="text.lightest" sx={{ fontSize: '16px' }} />
            </Box>
          )}
          <IconButton
            aria-label="close"
            size="medium"
            color="default"
            onClick={onClose}
            sx={{
              border: 'none',
              position: page === 'EntityConfig' ? 'absolute' : 'relative',
              right: page === 'EntityConfig' ? 0 : 'auto',
              top: page === 'EntityConfig' ? 0 : 'auto',
              m: page === 'EntityConfig' ? 4 : 0,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}

      <Box width={1} justifyContent="space-between" display="flex" alignItems="center">
        {renderEntityHeader ? (
          <>
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Box display="flex" gap={2} alignItems="center" justifyContent="center">
                <Box component="img" role='img' aria-label={`icon for ${entity.label} connector`}src={entity?.icon} width="40px" height="40px" sx={{ objectFit: 'contain' }} />
                <Box display="flex" flexDirection="column" gap={1}>
                  <Typography variant="h2">{entity?.label}</Typography>
                  <Typography variant="body2" color="text.lightish">
                    {entity?.widget_custom_params?.header?.subtitle || `Manage your ${entity?.label} connection`}
                  </Typography>
                </Box>
              </Box>
            </Box>
            {page === 'EntityConfig' && (
              <IconButton
                role='button'
                aria-label="close widget button"
                size="medium"
                color="default"
                onClick={onClose}
                sx={{
                  mr: 1,
                  border: 'none',
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </>
        ) : (
          company && (
            <Box className="company-logo-name">
              <Box
                component="img"
                src={company.logo}
                sx={{ width: '32px', height: '32px', objectFit: 'cover', filter: 'invert(1)' }}
              />
              <Typography variant="h2" fontWeight={700}>
                {company.name}
              </Typography>
            </Box>
          )
        )}
      </Box>
    </DialogTitle>
  );
};

export default Component;
